import api from "./api";

const BASE = "/ophthalmology";

export const getOphthalmologistProfile = () =>
  api.get(`${BASE}/ophthalmologist-profiles/`);

export const getOpticianProfile = () =>
  api.get(`${BASE}/optician-profiles/`);

export const getExaminations = (params = {}) =>
  api.get(`${BASE}/examinations/`, { params });

export const createExamination = (data) =>
  api.post(`${BASE}/examinations/`, data);

export const updateExamination = (id, data) =>
  api.patch(`${BASE}/examinations/${id}/`, data);

export const getLensPrescriptions = (params = {}) =>
  api.get(`${BASE}/lens-prescriptions/`, { params });

export const createLensPrescription = (data) =>
  api.post(`${BASE}/lens-prescriptions/`, data);

export const fillLensPrescription = (id) =>
  api.post(`${BASE}/lens-prescriptions/${id}/fill/`);

export const getPatientProfiles = (params = {}) =>
  api.get("/patient/profiles/", { params });

export const registerPatient = (data) =>
  api.post("/accounts/register-patient/", data);
